import { useEffect, useState } from "react"

export const useInstallPrompt = () => {
  const [promptEvent, setPromptEvent] = useState<any>(null)

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault()
      setPromptEvent(e)
    }
    window.addEventListener("beforeinstallprompt", handler)
    return () => window.removeEventListener("beforeinstallprompt", handler)
  }, [])

  const showPrompt = async () => {
    if (!promptEvent) return
    promptEvent.prompt()
    const choice = await promptEvent.userChoice
    if (choice.outcome === "accepted") setPromptEvent(null)
  }

  return { canInstall: !!promptEvent, showPrompt }
}